import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  CompareArrows as CompareArrowsIcon,
} from "@mui/icons-material";

// Função para obter o símbolo do operador
const getOperatorSymbol = (operator) => {
  const operatorMap = {
    equals: "==",
    notEquals: "!=",
    contains: "⊃",
    greaterThan: ">",
    lessThan: "<",
    greaterOrEqual: ">=",
    lessOrEqual: "<=",
    startsWith: "⊃⊃",
    endsWith: "⊂⊂",
    isEmpty: "∅",
    isNotEmpty: "!∅",
  };
  return operatorMap[operator] || operator;
};

// Componente do Nó
const ConditionCompareNode = memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  // Garantir que data existe
  if (!data) {
    data = {};
  }

  // Garantir dimensões válidas para evitar erro de raio negativo
  const nodeWidth = 200;
  const nodeHeight = 100;
  const handleSize = 18;

  return (
    <div
      style={{
        backgroundColor: "#FAFBFF",
        padding: "8px",
        borderRadius: "8px",
        maxWidth: `${nodeWidth}px`,
        boxShadow: "0px 3px 5px rgba(0,0,0,.05)",
        border: "1px solid rgba(104, 58, 200, 0.25)",
        width: nodeWidth,
        minHeight: `${nodeHeight}px`,
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#9a00ed",
          width: handleSize,
          height: handleSize,
          top: "20px",
          left: "-12px",
          cursor: "pointer",
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none"
          }}
        />
      </Handle>
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "12px", height: "12px", color: "#683AC8" }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "12px", height: "12px", color: "#683AC8" }}
        />
      </div>
      <div
        style={{
          color: "#ededed",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
          marginBottom: "8px",
        }}
      >
        <CompareArrowsIcon
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "#683AC8",
          }}
        />
        <div style={{ color: "#232323", fontSize: "16px" }}>Comparação</div>
      </div>
      <div style={{ color: "#232323", fontSize: "11px", marginBottom: "4px", wordBreak: "break-word" }}>
        {data?.leftValue || ""}
      </div>
      <div style={{ color: "#683AC8", fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>
        {getOperatorSymbol(data?.operator || "equals")}
      </div>
      <div style={{ color: "#232323", fontSize: "11px", wordBreak: "break-word" }}>
        {data?.rightValue || ""}
      </div>
      <Handle
        type="source"
        position="right"
        id="true"
        style={{
          top: 30,
          background: "#9a00ed",
          width: handleSize,
          height: handleSize,
          right: "-11px",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none"
          }}
        />
      </Handle>
      <Handle
        type="source"
        position="right"
        id="false"
        style={{
          bottom: 10,
          top: "auto",
          background: "#9a00ed",
          width: handleSize,
          height: handleSize,
          right: "-11px",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none"
          }}
        />
      </Handle>
    </div>
  );
});

ConditionCompareNode.displayName = "ConditionCompareNode";

// Exportar o componente do nó como default
export default ConditionCompareNode;